export default __webpack_public_path__ + "static/media/add.2ce57a1b.svg";